import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

type Tone = 'success' | 'warning' | 'danger' | 'neutral';

export type ProgressRingProps = {
  percent: number;
  size?: number;
  thickness?: number;
  tone?: Tone;
  label?: string;
};

export const ProgressRing = ({
  percent,
  size = 44,
  thickness = 4,
  tone,
  label,
}: ProgressRingProps) => {
  const theme = useTheme();

  const resolvedTone: Tone =
    tone ?? (percent >= 100 ? 'success' : percent <= 0 ? 'danger' : 'warning');

  const colorMap: Record<Tone, string> = {
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    danger:  theme.palette.error.main,
    neutral: theme.palette.grey[400],
  };
  const ringColor = colorMap[resolvedTone];

  return (
    <Box
      role="img"
      aria-label={label ?? `${percent} percent complete`}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: `conic-gradient(${ringColor} ${percent}%, ${theme.palette.divider} 0)`,
        display: 'grid',
        placeItems: 'center',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: `${thickness}px`,
          borderRadius: '50%',
          backgroundColor: 'background.paper',
        }}
      />
      <Typography
        component="span"
        sx={{
          position: 'relative',
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '-0.3px',
          color: 'text.primary',
        }}
      >
        {percent}
      </Typography>
    </Box>
  );
};
